export default "__VITE_ASSET__ea4ec5ab__"